<h3>VALIDATION DE VOTRE PANIER</h3>
<div class="row">
    <div class="col-md-12">
        <div class="card">
            <div class="card-block">
                <div class="h1">Panier</div>
                <div class="text-right">{{elementsNbr}} Artilce<span *ngIf="elementsNbr>1">s</span>
                </div>
            </div>
            <hr class="separator">
            <div class="card-body">
                <div class="card-items">
                    <table style="width: 100%">
                        <tbody>
                            <ng-container *ngFor="let el of order?.elements;let i=index">
                                <tr valign="middle">
                                    <td width="100">
                                        <div class="quantity-bloc">
                                            <button class="btn-plus" (click)="incrQty(i,0)">+</button>
                                            <button class="btn-quantity">{{el.qty}}</button>
                                            <button class="btn-minus" (click)="decrQty(i,0)">-</button>
                                        </div>
                                    </td>
                                    <td class="element-title">
                                        {{el.qty}}x {{el.name}} ({{el.size.size}}
                                        {{el.priceWithSupp | number : '1.2-2'}}
                                        €)
                                    </td>
                                    <td class="total text-right">
                                        {{el.total | number : '1.2-2'}}€
                                    </td>
                                    <td width="40" class="remove text-right">
                                        <i class="flaticon-garbage" role="button" (click)="removeElement(i,0)"></i>
                                    </td>
                                </tr>
                                <tr
                                    *ngIf="el.removedCompositions?.length>0 || el.optionIngredients?.length>0 || el.supplements?.length>0">
                                    <td></td>
                                    <td class="ing">
                                        <p *ngIf="el.removedCompositions?.length>0">
                                            <span class="ingTitle">sans :</span>
                                            <span *ngFor="let comp of el.removedCompositions">{{comp.text}}, </span>
                                        </p>
                                        <p *ngIf="el.optionIngredients?.length>0">
                                            <span class="ingTitle">options :</span>
                                            <span *ngFor="let opt of el.optionIngredients">{{opt.text}}, </span>
                                        </p>
                                        <p *ngIf="el.supplements?.length>0">
                                            <span class="ingTitle">supp :</span>
                                            <span *ngFor="let supp of el.supplements">{{supp.text}} ( {{supp.price}} €
                                                ),
                                            </span>
                                        </p>
                                        <p *ngIf="el.comment">
                                            <span class="ingTitle">Commentaire :</span>
                                            <span>{{el.comment}}</span>
                                        </p>
                                    </td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </ng-container>
                            <ng-container *ngFor="let menu of order?.menus;let i=index">
                                <tr valign="middle">
                                    <td>

                                    </td>
                                    <td class="element-title">
                                        {{menu.qty}}x {{menu.title}}
                                        <span *ngIf="menu.offer==null">{{menu.priceWithSupp | number : '1.2-2'}}
                                            €</span>
                                    </td>
                                    <td class="total text-right">
                                        {{menu.total | number : '1.2-2'}}€
                                    </td>
                                    <td width="40" class="remove text-right">
                                        <i class="flaticon-garbage" role="button" (click)="removeElement(i,1)"></i>
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td class="ing">
                                        <ul>
                                            <li *ngFor="let el of menu?.elements;let i=index">
                                                <ng-container *ngIf="el.qty>1">{{el.qty}}x</ng-container> {{el.name}}
                                                <span *ngIf="el.size.level>0">({{el.size.label}})</span>
                                                <p *ngIf="el.removedCompositions?.length>0">
                                                    <span class="ingTitle">sans :</span>
                                                    <span *ngFor="let opt of el.removedCompositions">{{opt.text}},
                                                    </span>
                                                </p>
                                                <p *ngIf="el.optionIngredients?.length>0">
                                                    <span class="ingTitle">options :</span>
                                                    <span *ngFor="let opt of el.optionIngredients">{{opt.text}}, </span>
                                                </p>
                                                <p *ngIf="el.supplements?.length>0">
                                                    <span class="ingTitle">supp :</span>
                                                    <span *ngFor="let opt of el.supplements">{{opt.text}} (
                                                        {{opt.price}}
                                                        €), </span>
                                                </p>
                                            </li>
                                            <li *ngFor="let el of menu?.additionalOptions">
                                                {{el.name}} ({{el.size}} {{el.price}} €)
                                            </li>
                                        </ul>
                                        <p>{{menu.comment}}</p>
                                    </td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </ng-container>
                        </tbody>
                        <tbody>
                            <tr *ngIf="order.discount>0 || order.coupon>0 || order.fees>0">
                                <td colspan="2">Sous-total </td>
                                <td class="text-right">{{order.amount | number : '1.2-2'}}€</td>
                                <td></td>
                            </tr>
                            <tr *ngIf="order.discount>0">
                                <td colspan="2">Remise {{order.discount}}% </td>
                                <td class="text-right">{{order.discountValue | number : '1.2-2'}}€</td>
                                <td></td>
                            </tr>
                            <tr *ngIf="order.coupon>0">
                                <td colspan="2">
                                    Coupon {{order.coupon}} <ng-container *ngIf="order.couponType==1">€</ng-container>
                                    <ng-container *ngIf="order.couponType==2">%</ng-container>
                                </td>
                                <td class="text-right">{{order.couponValue | number : '1.2-2'}}€</td>
                                <td></td>
                            </tr>
                            <tr *ngIf="order.fees>0">
                                <td colspan="2">{{order.feesLabel}} </td>
                                <td class="text-right">{{order.fees | number : '1.2-2'}}€</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td class="total" colspan="2">TOTAL TTC</td>
                                <td class="total text-right" width="100px">
                                    {{order?.total | number : '1.2-2'}} €
                                </td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="d-flex">
            <div class="continue">
                <a routerLink="/carte">
                    Continuer ma commande
                </a>
            </div>
            <div class="text-center validate">
                <button (click)="validate()">
                    <i class="flaticon-tick"></i>
                    <span>Valider la commande</span>
                </button>
            </div>
        </div>
    </div>
</div>
<ng-template #template>
    <div class="modal-body text-center">
        <p>
            <i class="fa fa-exclamation-triangle fa-2 text-navy" aria-hidden="true"></i>
        </p>
        <p>Vous êtes sur le point de modifier le mode de votre commande.</p>
        <p>Si vous continuez, votre panier sera automatiquement vidé. Continuer ?</p>
        <button type="button" class="btn btn-default mr-10" (click)="confirm()">OUI</button>
        <button type="button" class="btn btn-primary" (click)="decline()">NON</button>
    </div>
</ng-template>